import { AlkLogger } from '@alk/core';
/**
 * This function takes the event as a string and returns it as an object.
 *
 * @example
 * "data:somedata event:myevent" => { data: 'somedata', event: 'myevent' }
 *
 */
export function parseStringEventToObject(stringEvent) {
    AlkLogger.debug('[SSEvents]#RAW', stringEvent);
    const DATA = 'data';
    const EVENT = 'event';
    const ID = 'id';
    const keys = [DATA, EVENT, ID];
    const objectEvent = keys
        .map(key => ({ key, index: stringEvent.indexOf(`${key}:`) }))
        .sort((first, second) => first.index - second.index)
        .reduce((prev, curr, index, innerKeys) => {
        const next = { ...prev };
        const startIndex = curr.index + curr.key.length + 1;
        if (index + 1 < innerKeys.length) {
            // if not the last key
            next[curr.key] = stringEvent.slice(startIndex, innerKeys[index + 1].index).trim();
        }
        else {
            next[curr.key] = stringEvent.slice(startIndex).trim();
        }
        return next;
    }, {});
    try {
        objectEvent.data = JSON.parse(objectEvent.data);
    }
    catch {
        AlkLogger.debug(`[SSEvents]#PARSE ERROR, Cannot parse data for event ${objectEvent.event}`);
    }
    AlkLogger.debug('[SSEvents]#PARSED', objectEvent);
    return objectEvent;
}
